// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___oQeA0","root__lg":"style-module__root__lg___rsUdd","root__md":"style-module__root__md___X3Q2k","root__sm":"style-module__root__sm___mPSpN","root__paige":"style-module__root__paige___Rv3Ew"};
    if(module.hot) {
      // 1729151124840
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  